import { C1Icon } from 'components/core/icons/C1Icon'
import { ChevronDown } from 'lucide-react'
import React from 'react'

export const C1ButtonDropdownEndIcon = (): React.ReactElement => <C1Icon icon={ChevronDown} />
